<template>
  <section>
    <div class="audio-player text-md-center">
        <div class="audio-player-controls" sm6>
          <v-tooltip top v-if="!recording">
            <v-btn round color="success" dark @click.native.stop="grabar()" slot="activator">
              <v-icon>mic</v-icon>
            </v-btn>
            <span>Grabar</span>
          </v-tooltip>
          <v-tooltip top v-if="recording">
            <v-btn round color="error" dark @click.native.stop="detener()" slot="activator">
              <v-icon>stop</v-icon>
            </v-btn>
            <span>Grabar</span>
          </v-tooltip>
          <div class="audio-time">
            {{recordedTime}}
          </div>
          <v-tooltip top v-if="url">
            <v-btn flat icon color="error" dark @click.native.stop="limpiar()" slot="activator">
              <v-icon>clear</v-icon>
            </v-btn>
            <span>Limpiar</span>
          </v-tooltip>
        </div>
        <audio-player v-if="url" :file="url" :mime="'audio/mpeg'"></audio-player>
    </div>
  </section>
</template>
<script>
import Recorder from '@bigear/microphone-recorder';
import AudioPlayer from './Audio';
export default {
  props: [],
  created () {},
  beforeDestroy () {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  mounted () {},
  data () {
    return {
      audio: undefined,
      currentSeconds: 0,
      durationSeconds: 0,
      volume: 100,
      recording: false,
      input: null,
      mediaStreamObject: null,
      recorder: null,
      url: null,
      blob: null,
      base64: null,
      context: null,
      interval: null,
      seconds: 0
    };
  },
  computed: {
    recordedTime () {
      return new Date(this.seconds * 1000).toISOString().substr(11, 8);
    }
  },
  watch: {
    'base64' () {
      this.$emit('recuperar', this.base64);
    }
  },
  methods: {
    grabar () {
      this.limpiar();
      navigator.mediaDevices.getUserMedia({ audio: true }).then((mediaStreamObject) => {
        this.mediaStreamObject = mediaStreamObject;
        this.context = new (window.AudioContext || window.webkitAudioContext)();
        this.input = this.context.createMediaStreamSource(mediaStreamObject);

        this.recorder = new Recorder(this.input);
        this.recorder.record();
        this.recording = true;
        this.interval = setInterval(() => {
          this.seconds++;
        }, 1000);
      });
    },
    limpiar () {
      this.blob = null;
      this.base64 = null;
      this.url = null;
      this.seconds = 0;
    },
    async detener () {
      clearInterval(this.interval);
      this.mediaStreamObject.getAudioTracks()[0].stop();
      this.context.close();
      this.recording = false;
      this.recorder.stop();
      this.recorder.exportWAV('audio/mpeg', (blob) => {
        this.blob = blob;
        this.url = URL.createObjectURL(blob);
        this.recorder.clear();
        var reader = new FileReader();
        reader.readAsDataURL(this.blob);
        reader.addEventListener('load', (resultado) => {
          this.base64 = reader.result;
        });
      });
    }
  },
  updated () {},
  components: {Recorder, AudioPlayer}
};
</script>
<style src="./audio.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/common/plugins/audio/Recorder.vue